import { createBrowserRouter } from 'react-router-dom';
import { RootGate } from '@/components/RootGate';
import { DashboardPage } from '@/pages/DashboardPage';
import { ClientsPage } from '@/pages/ClientsPage';
import { ClientDetailPage } from '@/pages/client-detail/ClientDetailPage';
import { ClientCreatePage } from '@/pages/client-create/ClientCreatePage';
import { TestsCatalogPage } from '@/pages/TestsCatalogPage';
import { DataOperatorsPage } from '@/pages/DataOperatorsPage';
import { MarketingPage } from '@/pages/marketing/MarketingPage';
import { ReportsPage } from '@/pages/reports/ReportsPage';
import { RolesPage } from '@/pages/roles/RolesPage';
import { PortalUsersPage } from '@/pages/PortalUsersPage';
import { AdminsPage } from '@/pages/admins/AdminsPage';
import { SupportPage } from '@/pages/support/SupportPage';
import { SupportTicketPage } from '@/pages/support/SupportTicketPage';
import { EventsPage } from '@/pages/EventsPage';
import { ProfilePage } from '@/pages/ProfilePage';
import { LoginPage } from '@/pages/LoginPage';
import { NotFoundPage } from '@/pages/NotFoundPage';

/**
 * Маршруты:
 *  - /login  – точка входа (редирект на SSO). Отдельно от гейта: без сессии
 *    должна показываться сама по себе, без сайдбара/топбара приложения.
 *  - /       – RootGate: без сессии редиректит на /login (см. выше), с
 *    сессией – обычный каркас (AppLayout) с вложенными защищёнными страницами.
 *  - /clients – список клиентов, реальные данные (BFF → /admin-api старой админки);
 *  - остальные пункты бокового меню – заглушки до переноса соответствующих
 *    экранов Orchid (см. NAV_GROUPS в AppLayout).
 */
export const router = createBrowserRouter([
  { path: '/login', element: <LoginPage /> },
  {
    path: '/',
    element: <RootGate />,
    children: [
      { index: true, element: <DashboardPage /> },
      { path: 'clients', element: <ClientsPage /> },
      { path: 'clients/new', element: <ClientCreatePage /> },
      { path: 'clients/:id', element: <ClientDetailPage /> },
      { path: 'tests', element: <TestsCatalogPage /> },
      { path: 'admins', element: <AdminsPage /> },
      { path: 'portal-users', element: <PortalUsersPage /> },
      { path: 'roles', element: <RolesPage /> },
      { path: 'marketing', element: <MarketingPage /> },
      { path: 'data-operators', element: <DataOperatorsPage /> },
      { path: 'events', element: <EventsPage /> },
      { path: 'reports', element: <ReportsPage /> },
      { path: 'support', element: <SupportPage /> },
      { path: 'support/:id', element: <SupportTicketPage /> },
      { path: 'profile', element: <ProfilePage /> },
      { path: '*', element: <NotFoundPage /> },
    ],
  },
]);
